export default __webpack_public_path__ + "static/img_welfare_1-9cf3d66266191978e08778e70349128c.jpg";